import React, { Component, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Modal,
  Button,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import TopnavEasyAccess from './Topnav.EasyAccess';
import Select from 'react-select';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
  AxiosPublicAPI,
  getUserRole,
} from '../../helpers/AxiosAPI';
import {
  gAPI_Subscription_By_Group_Id,
  gAPI_BotConversations_list,
  gAPI_AgentConversations_list,
  gAPI_Group_By_Id,
  gAPI_LinkedGrups_By_Id,
  gAPI_Users_LinkedProperties_By_Id,
  gAPI_Users_LinkedGrups_By_Id,
  putAPI_AgentStatus,
  putAPI_UpdateAgentStatus_By_Id,
  postApi_Billing_Details_US,
  postApi_Billing_Details,
  gAPI_Site_Settings,
  gAPI_Internal_Property_By_Id,
  gAPI_OnboardSessionStatus,
  getAPI_OnboardSetUpWizardByGroupId,
} from '../../constants/APIs';
import { reactSelectProperties } from '../../helpers/Utils';
import {
  setContainerClassnames,
  clickOnMobileMenu,
  logoutUser,
  changeLocale,
  changeProperty,
  changePropertyProvider,
  getPropertyList,
  changeTimeZone,
  changeCurrency,
  changeGroupBillingCurrency,
  ConnectUser,
  SetAgent,
  BotBlink,
  AgentBlink,
  changeServiceProviderLogo,
  changeServiceProvider,
  fetchTwilioConversationsRequest,
} from '../../redux/actions';
import TwilioConversationApp from '../../views/app/pages/conversations/components/TwilioConversationApp';
import {
  menuHiddenBreakpoint,
  searchPath,
  localeOptions,
  themeColorStorageKey,
  isDarkSwitchActive,
} from '../../constants/defaultValues';
import { MobileMenuIcon, MenuIcon } from '../../components/svg';
import { getDirection, setDirection } from '../../helpers/Utils';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import moment from 'moment';
import { BusinessProfile } from '../pages/BussinessProfile';
import Intercom from './Intercom';
import TopnavDarkSwitch from './Topnav.DarkSwitch';
import IntlMessages from '../../helpers/IntlMessages';
import { MdOutlineAirplanemodeActive } from 'react-icons/md';

// ─── Fix #5: Centralised authority-server helper ──────────────────────────────
// Previously copy-pasted 5+ times across methods. Now a single function.
function getAuthorityServer() {
  const host = window.location.hostname.toLowerCase();
  if (host.includes('sabre'))
    return process.env.REACT_APP_SABRE_AUTHORITY_SERVER;
  if (host.includes('synxis'))
    return process.env.REACT_APP_SYNXIS_AUTHORITY_SERVER;
  if (host.includes('myma.ai'))
    return process.env.REACT_APP_MYMA_AUTHORITY_SERVER;
  if (host.includes('smartpabx.ai'))
    return process.env.REACT_APP_SMARTPABX_AI_AUTHORITY_SERVER;
  return process.env.REACT_APP_AUTHORITY_SERVER;
}

const AVATAR_CDN_ORIGIN = 'https://bmbuiassetsprod.blob.core.windows.net';
const DEFAULT_AVATAR = `${AVATAR_CDN_ORIGIN}/images/profile_pic.png`;

class TopNav extends Component {
  constructor(props) {
    super(props);
    this.cachedIcon = null;
    this.state = {
      isInFullScreen: false,
      searchKeyword: '',
      hotel: { value: '-1', label: 'All' },
      hotelName: 'All',
      stripeCustomerId: '',
      showTwilioConversationList: false,
      showBotConversationOn: false,
      showAgentConversation: false,
      botConversationList: [],
      agentConversationList: [],
      groupsList: [],
      linkedGroups: [],
      isAivaProperty: false,
      websiteLink: '',
      rooms: 0,
      starRating: 0,
      type: '',
      groupName: '',
      NotificationTitle: '',
      showLinkedGroups: false,
      loading: false,
      chatInvitations: [],
      showAgentStatus: false,
      agentStatus: false,
      activationdate: '',
      bussinessProfileVisible: false,
      propertyList: this.props.plist,
      helpcenterUrl: '',
      isShowChat: false,
      isWizard: false,
      wizardStatus: null,
      notificationSettings: {
        sound: false,
        browser: false,
        mac: false,
        windows: false,
      },
    };

    // Ref used inside SignalR handlers so they always see current props/state
    // Fix #5 (stale closure): handlers read this.propsRef.current instead of
    // the captured snapshot from registration time.
    this.propsRef = { current: props };

    // Create audio element with muted initially to allow autoplay
    this.audio = new Audio(`${AVATAR_CDN_ORIGIN}/images/chat1.mp3`);
    this.audio.preload = 'auto';
    this.audioReady = false;

    // Try to unmute after first user interaction
    if (typeof document !== 'undefined') {
      const enableAudio = () => {
        this.audio.muted = false;
        this.audioReady = true;
        // Remove listeners after first interaction
        document.removeEventListener('click', enableAudio);
        document.removeEventListener('scroll', enableAudio);
        document.removeEventListener('keydown', enableAudio);
      };

      document.addEventListener('click', enableAudio);
      document.addEventListener('scroll', enableAudio);
      document.addEventListener('keydown', enableAudio);
    }
  }

  // ─── Keep ref in sync ──────────────────────────────────────────────────────
  componentDidUpdate(prevProps) {
    this.propsRef.current = this.props;

    // --- Logic previously in componentWillReceiveProps ---
    const props = this.props;

    // 1. pid change
    if (props.pid && props.pid !== prevProps.pid) {
      if (props.pid !== '-1') {
        AxiosAPI({
          method: 'get',
          url: `${gAPI_Internal_Property_By_Id}/${props.pid}?group_id=${getGroupID()}`,
        })
          .then((res) => {
            this.setState({ isWizard: res.data?.isWizard === true });
            this.props.changePropertyProvider(
              res.data?.providerPropertyId || ''
            );
          })
          .catch((err) => {
            console.error('Error loading property wizard flag', err);
          });
      } else {
        this.setState({ isWizard: false });
      }
    }

    // 2. signalRConnection.newConnection change
    if (
      props.signalRConnection.newConnection !== undefined &&
      prevProps.signalRConnection.newConnection === undefined
    ) {
      const { intl } = props;
      const newMsgTitle = intl.formatMessage({
        id: 'dashboard.new_chat_message',
      });
      const dismissText = intl.formatMessage({ id: 'content.dismiss' });
      const openText = intl.formatMessage({ id: 'content.open' });

      const user = this.props.userData;
      const userProperties = [];
      if (user.properties.length > 0) {
        if (user.properties[0] === '-1') {
          this.props.plist.forEach((p) => userProperties.push(p.id));
        } else {
          user.properties.forEach((p) => userProperties.push(p));
        }
      }

      props.signalRConnection.newConnection.connection
        .invoke('SendMessage', {
          recipient: getUserID(),
          groupname: userProperties,
        })
        .catch((err) => console.error(err.toString()));

      props.signalRConnection.newConnection.connection.on(
        'newChatUserMessage',
        (message) => {
          console.log('FULL MESSAGE 1 =>', message);
          window.updateFaviconBadge(true);
          // Fix #5 (stale closure): always read current props via the ref
          const currentProps = this.propsRef.current;
          if (this.shouldSendNotification()) {
            if (message.Source === 'Visitor') {
              const latestMsg = message.Content.messages?.slice(-1)[0];

              this.handleNotificationPopup({
                ...message,
                text: latestMsg,
              });
            }
            //uncomment below to show all messages in the notification instead of just the first one
            // message.Content.messages.forEach((msg) => {
            //   this.handleNotificationPopup(msg);
            // });
          }
          if (message.Source === 'Visitor') {
            const onAgentAssistPage =
              typeof window !== 'undefined' &&
              window.location?.pathname?.includes('pages/agent-assist');

            if (
              !onAgentAssistPage &&
              currentProps.twilioConversationsReducer.twilioConversations
                ?.length > 0
            ) {
              const conversation =
                currentProps.twilioConversationsReducer.twilioConversations.find(
                  (c) =>
                    c.channelState.uniqueName.includes(
                      message.BotConversationId
                    )
                );

              if (conversation) {
                try {
                  this._ensurePopupStyles();

                  let container = document.getElementById(
                    'myma_chat_popup_container'
                  );
                  if (!container) {
                    container = document.createElement('div');
                    container.id = 'myma_chat_popup_container';
                    container.className = 'myma-chat-popup-container';
                    document.body.appendChild(container);
                  }

                  let contentMsg = '';
                  if (
                    message.Content?.type === 'messages' &&
                    message.Content.messages.length > 0
                  ) {
                    contentMsg = String(message.Content.messages[0]);
                  }
                  const botMsg = contentMsg || 'New media message received';

                  const popupId = `myma_chat_popup_${
                    conversation.channelState.uniqueName || Date.now()
                  }`;

                  const existing = document.getElementById(popupId);
                  if (existing) existing.remove();

                  // Fix #1 (XSS): build popup entirely with DOM APIs + textContent
                  const popup = this._buildChatPopup({
                    popupId,
                    newMsgTitle,
                    dismissText,
                    openText,
                    botMsg,
                    message,
                  });

                  container.appendChild(popup);
                } catch (err) {
                  console.error('Error showing styled chat popup:', err);
                }
              }
            }
          }

          if (message.Source === 'Visitor' && message.AgentId === getUserID()) {
            if (document.visibilityState !== 'visible') {
              window.updateFaviconBadge(true);
            }
            console.log('FULL MESSAGE =>', message);
            const latestMsg = message.Content.messages?.slice(-1)[0];
            this.handleNotificationPopup({
              ...message,
              text: latestMsg,
            });
            // this.handleNotificationPopup(message.Content.messages[0]);
            //uncomment below to show all messages in the notification instead of just the first one
            // message.Content.messages.forEach((msg) => {
            //   this.handleNotificationPopup(msg);
            // });
            if (this.state.notificationSettings.sound) {
              this.playNotificationSound();
            }
            this.props.AgentBlink(true);
            setTimeout(() => {
              this.setState({ showAgentConversation: false });
            }, 60000);
          }
        }
      );

      props.signalRConnection.newConnection.connection.on('newChat', () => {
        if (document.visibilityState !== 'visible') {
          window.updateFaviconBadge(true);
        }

        if (this.state.notificationSettings.sound) {
          this.playNotificationSound();
        }
        this.props.BotBlink(true);
        setTimeout(() => {
          this.setState({ showBotConversationOn: false });
        }, 60000);
      });

      props.signalRConnection.newConnection.connection.on(
        'newAgentChat',
        (message) => {
          if (this.state.agentStatus) {
            AxiosAPI({
              method: 'put',
              url: `${putAPI_UpdateAgentStatus_By_Id}/${message}`,
              data: {
                groupId: getGroupID(),
                userId: getUserID(),
                status: 'RequestReceived',
              },
            });

            const alreadyQueued = this.state.chatInvitations.includes(message);
            if (!alreadyQueued) {
              if (this.shouldSendNotification()) {
                this.handleNotificationPopup('New chat request arrived');
              }
              this.setState((prev) => ({
                chatInvitations: [message, ...prev.chatInvitations],
              }));
              if (document.visibilityState !== 'visible') {
                window.updateFaviconBadge(true);
              }
              if (this.state.notificationSettings.sound) {
                this.playNotificationSound();
              }
              this.props.AgentBlink(true);
              setTimeout(() => {
                this.setState({ showAgentConversation: false });
              }, 60000);
            }
          }
        }
      );
    }

    // 3. Bot conversation blink state
    if (
      (props.signalRConnection.newConnection !== undefined &&
        prevProps.signalRConnection.newConnection === undefined &&
        props.signalRConnection.botBlink !== undefined &&
        prevProps.signalRConnection.botBlink === undefined) ||
      (props.signalRConnection.newConnection !== undefined &&
        props.signalRConnection.botBlink !== undefined &&
        props.signalRConnection.botBlink !==
          prevProps.signalRConnection.botBlink)
    ) {
      this.setState({
        showBotConversationOn: props.signalRConnection.botBlink === true,
      });
    }

    // 4. Agent conversation blink state
    if (
      (props.signalRConnection.newConnection !== undefined &&
        prevProps.signalRConnection.newConnection === undefined &&
        props.signalRConnection.agentBlink !== undefined &&
        prevProps.signalRConnection.agentBlink === undefined) ||
      (props.signalRConnection.newConnection !== undefined &&
        props.signalRConnection.agentBlink !== undefined &&
        props.signalRConnection.agentBlink !==
          prevProps.signalRConnection.agentBlink)
    ) {
      this.setState({
        showAgentConversation: props.signalRConnection.agentBlink === true,
      });
    }
  }

  // ─── Fix #1 (XSS): popup built entirely with DOM APIs ─────────────────────
  _buildChatPopup({
    popupId,
    newMsgTitle,
    dismissText,
    openText,
    botMsg,
    message,
  }) {
    const popup = document.createElement('div');
    popup.id = popupId;
    popup.className = 'myma-chat-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-live', 'polite');

    // Header
    const header = document.createElement('div');
    header.className = 'header';

    const avatarDiv = document.createElement('div');
    avatarDiv.className = 'avatar';
    const avatarImg = document.createElement('img');
    avatarImg.alt = 'user';
    // Validate avatar URL is from trusted CDN
    const rawSrc = DEFAULT_AVATAR;
    avatarImg.src =
      typeof rawSrc === 'string' && rawSrc.startsWith(AVATAR_CDN_ORIGIN)
        ? rawSrc
        : DEFAULT_AVATAR;
    avatarDiv.appendChild(avatarImg);

    const titleWrap = document.createElement('div');
    titleWrap.style.cssText = 'flex:1;position:relative';
    const titleEl = document.createElement('div');
    titleEl.className = 'title';
    titleEl.textContent = newMsgTitle; // safe: textContent, not innerHTML
    titleWrap.appendChild(titleEl);

    const closeX = document.createElement('button');
    closeX.className = 'close-x';
    closeX.setAttribute('aria-label', 'Dismiss');
    closeX.textContent = '\u00D7'; // × character — no innerHTML

    header.append(avatarDiv, titleWrap, closeX);

    // Body
    const body = document.createElement('div');
    body.className = 'body';
    body.textContent = botMsg; // safe: textContent, not innerHTML

    // Actions
    const actions = document.createElement('div');
    actions.className = 'actions';

    const dismissBtn = document.createElement('button');
    dismissBtn.className = 'btn-dismiss add-button btn btn-secondary btn-xs';
    dismissBtn.textContent = dismissText;

    const openBtn = document.createElement('button');
    openBtn.className = 'btn-open add-button btn btn-primary btn-xs';
    openBtn.textContent = openText;

    actions.append(dismissBtn, openBtn);
    popup.append(header, body, actions);

    // Event handlers
    const navigate = () => {
      try {
        this.props.BotBlink(false);
        this.props.AgentBlink(false);
        this.props.history.push({
          pathname: '/app/pages/agent-assist',
          state: {
            incomingPopChatId: message.ConversationId,
            activeTab: 'Active',
          },
        });
      } catch {
        window.location.href = '/app/pages/agent-assist';
      }
      popup.remove();
    };

    closeX.addEventListener('click', (e) => {
      e.stopPropagation();
      popup.remove();
    });
    dismissBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      popup.remove();
    });
    openBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      navigate();
    });
    popup.addEventListener('click', (e) => {
      if (e.target.closest('button')) return;
      navigate();
    });

    return popup;
  }

  // Inject popup styles once
  _ensurePopupStyles() {
    if (document.getElementById('myma-chat-popup-styles')) return;
    const style = document.createElement('style');
    style.id = 'myma-chat-popup-styles';
    style.textContent = `
      @keyframes myma-popup-in { from { transform: translateY(12px) scale(.98); opacity: 0 } to { transform: translateY(0) scale(1); opacity: 1 } }
      .myma-chat-popup-container { position: fixed; right: 20px; bottom: 20px; z-index: 2147483647; display:flex; flex-direction: column; gap: 12px; align-items: flex-end; pointer-events: none; }
      .myma-chat-popup { pointer-events: auto; width: 340px; background: linear-gradient(180deg,#fff,#fbfdff); border-radius: 10px; border: 1px solid rgba(15,23,36,0.08); box-shadow: 0 10px 30px rgba(18,36,63,0.12); overflow: hidden; font-family: Inter, Roboto, "Helvetica Neue", Arial, sans-serif; color:#1f2937; animation: myma-popup-in .18s ease both; }
      .myma-chat-popup .header { display:flex; align-items:center; gap:10px; padding:12px 12px 6px 12px; }
      .myma-chat-popup .avatar { width:40px; height:40px; border-radius:8px; object-fit:cover; display:flex; align-items:center; justify-content:center; overflow:hidden; }
      .myma-chat-popup .avatar img { width:100%; height:100%; object-fit:cover; display:block; }
      .myma-chat-popup .title { font-weight:600; font-size:14px; line-height:1; color:#0f1724; }
      .myma-chat-popup .body { padding:6px 12px 12px 12px; font-size:13px; color:#0f1724; max-height:110px; overflow:auto; line-height:1.35; }
      .myma-chat-popup .actions { display:flex; justify-content:flex-end; gap:8px; padding:8px 12px 12px 12px; }
      .myma-chat-popup .close-x { position:absolute; right:8px; top:6px; background:transparent; border:0; font-size:16px; color:#94a3b8; cursor:pointer; }
      @media (max-width:420px){ .myma-chat-popup{ width:calc(100% - 40px); } .myma-chat-popup-container{ right:10px; left:10px; align-items:center; } }
    `;
    document.head.appendChild(style);
  }

  // ─── Fix #3 (timer leak): clear interval on unmount ───────────────────────
  componentWillUnmount() {
    if (this.interval) clearInterval(this.interval);
  }

  handleAivaRedirect = (groupId) => {
    this.setState({ loading: true });
    const AUTHORITY_SERVER = getAuthorityServer(); // Fix #5
    window.location.href = `${AUTHORITY_SERVER}/Aiva/AivaRedirection/${getUserID()}?groupId=${groupId}`;
  };

  acceptChat(id) {
    this.setState((prev) => ({
      chatInvitations: prev.chatInvitations.filter((inv) => inv !== id),
    }));
    this.props.BotBlink(false);
    this.props.AgentBlink(false);
    this.props.history.push({
      pathname: '/app/pages/agent-assist',
      state: { incomingchatId: id, activeTab: 'Active' },
    });
  }

  componentDidMount() {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Group_By_Id}/${getGroupID()}`,
    }).then((res) => {
      if (res.data.logo) this.props.changeServiceProviderLogo(res.data.logo);
      if (res.data.serviceProvider)
        this.props.changeServiceProvider(res.data.serviceProvider);
      if (res.data.billingCurrency)
        this.props.changeGroupBillingCurrency(res.data.billingCurrency);
      this.fetchColorTheme(res.data.serviceProvider);
    });

    if (this.props.pid && this.props.pid !== '-1') {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${this.props.pid}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          this.setState({ isWizard: res.data?.isWizard === true });
          this.props.changePropertyProvider(res.data?.providerPropertyId || '');
        })
        .catch((err) =>
          console.error('Error loading property wizard flag', err)
        );
    }

    this.setNotification();
    // Load saved notification settings from localStorage
    try {
      const saved = localStorage.getItem('myma_notification_settings');
      if (saved) {
        const settings = JSON.parse(saved);
        this.setState({ notificationSettings: settings });
      }
    } catch (err) {
      console.error('Failed to load notification settings:', err);
    }
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Subscription_By_Group_Id}?groupid=${getGroupID()}`,
    }).then((res) => {
      if (res.data.stripeCustomerId) {
        this.setState({ stripeCustomerId: res.data.stripeCustomerId });
      }
    });

    if (
      this.props.plist.filter((f) => f.isBmb === true).length === 0 &&
      this.props.plist.filter((f) => f.isAiva === true).length > 0
    ) {
      this.handleAivaRedirect(getGroupID());
    } else {
      if (
        this.props.plist.filter((f) => f.id === this.props.pid).length !== 0 ||
        this.props.pid === '-1'
      )
        this.setHotelName(this.props.pid);
      else this.setHotelName(this.props.plist[0].id);
    }

    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_LinkedProperties_By_Id}?id=${getUserID()}&gid=${getGroupID()}&pid=${this.props.propertyId}&bmb=true&aiva=true`,
    }).then((res) => {
      if (res.data?.status === 'True') this.setState({ isAivaProperty: true });
    });

    AxiosAPI({
      method: 'get',
      url: `${gAPI_LinkedGrups_By_Id}/${getUserID()}`,
    }).then((res) => {
      this.setState({ linkedGroups: res.data, groupsList: res.data });
    });

    const user = this.props.userData;
    let agent = false;
    if (user) {
      user.roles.forEach((r) => {
        if (r === 'Agent') {
          agent = true;
          this.setState({
            showAgentStatus: true,
            agentStatus: user.onlineStatus,
          });
          this.props.ConnectUser();
          this.props.fetchTwilioConversationsRequest();
        }
      });
    }
    if (!agent) this.props.SetAgent(false);

    this.getWizardSessionStatus();

    // Fix #3 (timer leak): store ref so componentWillUnmount can clear it
    this.interval = setInterval(() => {
      if (this.state.timeZone) {
        this.setState({
          propertyTime: this.getPropertyTime(this.state.timeZone),
        });
      }
    }, 60000);
  }

  setHotelName = (id) => {
    const hotel = this.props.plist.find((elem) => elem.id === id);
    if (hotel) {
      this.props.changeProperty(id);
      this.props.changeCurrency(hotel.currency);
      this.props.changeTimeZone(hotel.timeZone);
      this.setState({
        hotelName: hotel.name,
        websiteLink: hotel.websiteLink,
        rooms: hotel.rooms,
        starRating: hotel.starRating,
        type: hotel.type,
        groupName: hotel.groupName,
        activationdate: hotel.activationDate,
        propertyTime: this.getPropertyTime(hotel.timeZone),
        timeZone: hotel.timeZone || 'UTC',
      });
    } else {
      console.log('Property not found:', id);
    }
  };

  handleChangeLocale = (locale, direction) => {
    this.props.changeLocale(locale);
    setTimeout(() => window.location.reload(), 500);
  };

  handleChangePropertyID = (propertyId, timeZone, currency) => {
    this.props.changeProperty(propertyId);
    this.props.changeTimeZone(timeZone);
    this.props.changeCurrency(currency);
    const AUTHORITY_SERVER = getAuthorityServer(); // Fix #5
    setTimeout(() => {
      window.location.href = `${AUTHORITY_SERVER}/Account/SwitchGroup/${getUserID()}?groupId=${getGroupID()}&propertyId=${propertyId}`;
    }, 500);
  };

  handleChangeSelect = (e) => {
    this.setState({ loading: true });
    const parts = e.value.split('|');
    const groupId = parts[0];
    const propertyId = parts[1] || '';
    const AUTHORITY_SERVER = getAuthorityServer(); // Fix #5
    window.location.href = `${AUTHORITY_SERVER}/Account/SwitchGroup/${getUserID()}?groupId=${groupId}&propertyId=${propertyId}`;
  };

  handleChangePropertyIDAll = () => {
    this.props.changeProperty('-1');
    this.props.changeTimeZone('Etc/GMT');
    this.props.changeCurrency('');
    const AUTHORITY_SERVER = getAuthorityServer(); // Fix #5
    setTimeout(() => {
      window.location.href = `${AUTHORITY_SERVER}/Account/SwitchGroup/${getUserID()}?groupId=${getGroupID()}&propertyId=-1`;
    }, 500);
  };

  isInFullScreen = () =>
    !!(
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    );

  handleSearchIconClick = (e) => {
    if (window.innerWidth < menuHiddenBreakpoint) {
      let elem = e.target;
      if (!e.target.classList.contains('search')) {
        if (e.target.parentElement.classList.contains('search'))
          elem = e.target.parentElement;
        else if (
          e.target.parentElement.parentElement.classList.contains('search')
        )
          elem = e.target.parentElement.parentElement;
      }
      if (elem.classList.contains('mobile-view')) {
        this.search();
        elem.classList.remove('mobile-view');
        this.removeEventsSearch();
      } else {
        elem.classList.add('mobile-view');
        this.addEventsSearch();
      }
    } else {
      this.search();
    }
  };

  addEventsSearch = () =>
    document.addEventListener('click', this.handleDocumentClickSearch, true);
  removeEventsSearch = () =>
    document.removeEventListener('click', this.handleDocumentClickSearch, true);

  handleDocumentClickSearch = (e) => {
    let isSearchClick = false;
    if (
      e.target?.classList?.contains('navbar') ||
      e.target?.classList?.contains('simple-icon-magnifier')
    ) {
      isSearchClick = true;
      if (e.target.classList.contains('simple-icon-magnifier')) this.search();
    } else if (e.target.parentElement?.classList?.contains('search')) {
      isSearchClick = true;
    }
    if (!isSearchClick) {
      document.querySelector('.mobile-view')?.classList.remove('mobile-view');
      this.removeEventsSearch();
      this.setState({ searchKeyword: '' });
    }
  };

  handleSearchInputChange = (e) =>
    this.setState({ searchKeyword: e.target.value });

  handleSearchInputKeyPress = (e) => {
    if (e.key === 'Enter') this.search();
  };

  handleAgentConversationClick = () => {
    this.props.AgentBlink(false);
    this.props.history.push('/app/pages/agent-assist');
  };

  search = () => {
    this.props.history.push(searchPath + '/' + this.state.searchKeyword);
    this.setState({ searchKeyword: '' });
  };

  toggleSwitchAccount = () =>
    this.setState((prev) => ({ showLinkedGroups: !prev.showLinkedGroups }));
  twilioStartChat = () => this.setState({ showTwilioConversationList: true });

  toggleBussinessPopup = (e) => {
    e.preventDefault();
    this.props.history.push('/app/pages/business-settings');
  };

  toggleFullScreen = () => {
    const inFS = this.isInFullScreen();
    const docElm = document.documentElement;
    if (!inFS) {
      (
        docElm.requestFullscreen ||
        docElm.mozRequestFullScreen ||
        docElm.webkitRequestFullScreen ||
        docElm.msRequestFullscreen
      )?.call(docElm);
    } else {
      (
        document.exitFullscreen ||
        document.webkitExitFullscreen ||
        document.mozCancelFullScreen ||
        document.msExitFullscreen
      )?.call(document);
    }
    this.setState({ isInFullScreen: !inFS });
  };

  handleChangePassword = () =>
    this.props.history.push('/app/pages/users/change-password');
  handleSubscription = () =>
    this.props.history.push('/app/pages/billing/subscription');
  handleSetupWizard = () => this.props.history.push('/app/pages/templates');

  handleLatestBotConversation = () => {
    this.props.BotBlink(false);
    this.props.history.push({
      pathname: '/app/pages/agent-assist',
      state: { from: 'NavBar' },
    });
  };

  handleInvoices = () => this.StripeCustmerPortal(this.state.stripeCustomerId);

  StripeCustmerPortal = (customerID) => {
    const qs = require('qs');
    const data = qs.stringify({
      customer: customerID,
      return_url: window.location.href,
    });
    AxiosAPI({
      method: 'post',
      url: `${postApi_Billing_Details}?url=v1/billing_portal/sessions`,
      data,
    })
      .then((res) => window.open(res.data.url, '_blank'))
      .catch(() => {
        AxiosAPI({
          method: 'post',
          url: `${postApi_Billing_Details_US}?url=v1/billing_portal/sessions`,
          data,
        }).then((res) => window.open(res.data.url, '_blank'));
      });
  };

  // ─── Fix #4 (logout crash): guard session storage read ────────────────────
  handleLogout = (e) => {
    e.preventDefault();
    const AUTHORITY_SERVER = getAuthorityServer(); // Fix #5
    try {
      const raw = sessionStorage.getItem(
        `oidc.user:${AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
      );
      if (!raw) throw new Error('Session not found');
      const { id_token } = JSON.parse(raw);
      window.location.href = `${AUTHORITY_SERVER}/Account/Logout?logoutId=${id_token}`;
    } catch (err) {
      console.error('Logout error — redirecting to authority root:', err);
      window.location.href = `${AUTHORITY_SERVER}/Account/Logout`;
    }
  };

  handlePrivacy = (e) => {
    e.preventDefault();
    window.open('https://www.myma.ai/privacy-policy');
  };

  handleWebsiteLink = (e) => {
    e.preventDefault();
    const url = this.state.websiteLink;
    if (!url) return;
    window.open(url.startsWith('http') ? url : `https://${url}`, '_blank');
  };

  menuClickButton = (e) => {
    e.preventDefault();
    if (this.props.onMenuIconClick) this.props.onMenuIconClick();
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    e.preventDefault();
    setTimeout(() => {
      const event = document.createEvent('HTMLEvents');
      event.initEvent('resize', false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      ++menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems
    );
  };

  mobileMenuButtonClick = (e, containerClassnames) => {
    e.preventDefault();
    this.props.clickOnMobileMenu(containerClassnames);
  };

  fetchColorTheme = (serviceProvider) => {
    AxiosAPI({ method: 'get', url: `${gAPI_Site_Settings}` })
      .then((res) => {
        const match = res.data.find(
          (item) => item.id.toString() === serviceProvider
        );
        if (match) {
          this.setState({
            helpcenterUrl: match.helpCenterUrl,
            isShowChat: match.isShowChat,
            serviceProviderName: match.fromName,
          });
          localStorage.setItem(
            themeColorStorageKey,
            match.colorTheme || 'light.purple'
          );
        } else {
          localStorage.setItem(themeColorStorageKey, 'light.purple');
        }
      })
      .catch((err) => console.error('Error fetching color theme:', err));
  };

  setNotification = () => {
    if (!('Notification' in window)) return;
    this.setState({
      NotificationTitle:
        Notification.permission === 'granted'
          ? 'Notifications Allowed'
          : 'Allow Notifications',
    });
  };
  parseNotificationMessage = (msg) => {
    try {
      if (typeof msg !== 'string') return msg;

      const parsed = JSON.parse(msg);

      // Case 1: Array format
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed[0]?.caption || parsed[0]?.text || msg;
      }

      // Case 2: Hero card / content structure
      if (parsed?.content?.text) {
        return parsed.content.text;
      }

      // Case 3: simple object
      if (parsed?.caption) {
        return parsed.caption;
      }

      return msg;
    } catch (err) {
      return msg;
    }
  };
  getResizedIcon = async (url) => {
    if (!url) return url;

    if (this.cachedIcon) return this.cachedIcon;

    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const size = 64;

      canvas.width = size;
      canvas.height = size;

      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = url;

      img.onload = () => {
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, size, size);

        //maintain aspect ratio (no crop)
        const scale = Math.min(size / img.width, size / img.height);
        const newWidth = img.width * scale;
        const newHeight = img.height * scale;

        const x = (size - newWidth) / 2;
        const y = (size - newHeight) / 2;

        ctx.drawImage(img, x, y, newWidth, newHeight);

        const resized = canvas.toDataURL();
        this.cachedIcon = resized;
        resolve(resized);
      };

      img.onerror = () => {
        resolve(url);
      };
    });
  };
  handleNotificationPopup = async (msg) => {
    if (!this.shouldSendNotification()) return;
    const notificationTitle =
      this.state.serviceProviderName?.trim() || 'Myma.ai';
    const { notificationSettings } = this.state;
    const cleanMessage = this.parseNotificationMessage(msg?.text || msg);
    const conversationId = msg.ConversationId || 'default';
    const iconUrl =
      this.props.serviceProviderLogo ||
      `${AVATAR_CDN_ORIGIN}/images/newlogo.png`;
    const notificationIcon = await this.getResizedIcon(iconUrl);
    //const notificationIcon =
    //  this.props.serviceProviderLogo || DEFAULT_FALLBACK_ICON;
    if (notificationSettings.browser && 'Notification' in window) {
      const show = () => {
        try {
          const notification = new Notification(notificationTitle, {
            body: cleanMessage,
            icon: notificationIcon,
            tag: 'myma-' + conversationId,
            requireInteraction: false,
          });

          notification.onclick = () => {
            window.focus();
            window.location.href = '/app/pages/agent-assist';
            notification.close();
          };
        } catch (error) {
          console.error('Browser notification error:', error);
        }
      };

      if (Notification.permission === 'granted') {
        this.setState({ NotificationTitle: 'Notifications Allowed' });
        show();
      } else if (Notification.permission === 'default') {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            this.setState({ NotificationTitle: 'Notifications Allowed' });
            show();
          }
        });
      }
    }

    try {
      if (typeof window !== 'undefined' && window.require) {
        const { ipcRenderer } = window.require('electron');

        if (notificationSettings.mac) {
          ipcRenderer.send('show-notification', {
            platform: 'mac',
            title: notificationTitle,
            body: cleanMessage,
            icon: notificationIcon,
          });
        }

        if (notificationSettings.windows) {
          ipcRenderer.send('show-notification', {
            platform: 'windows',
            title: notificationTitle,
            body: cleanMessage,
            icon: notificationIcon,
          });
        }
      }
    } catch (err) {
      console.log('Electron not available (web environment)');
    }

    if (notificationSettings.sound) {
      this.playNotificationSound();
    }
  };

  playNotificationSound = () => {
    try {
      if (!this.audioReady) {
        console.warn('🔇 User interaction required before playing sound');
        return;
      }

      const audioClone = this.audio.cloneNode();

      audioClone.play().catch((err) => {
        console.warn('Audio blocked:', err.message);
      });
    } catch (err) {
      console.error('Sound error:', err);
    }
  };
  showSoundFallback = () => {
    // Optional: Show a visual indicator that sound would have played
    // This is a fallback when autoplay is blocked
    console.log(
      'Sound notification blocked by browser - user can enable in settings'
    );

    // Optional: Flash the favicon or show toast notification
    if (document.visibilityState !== 'visible') {
      window.updateFaviconBadge(true);
    }

    // Reset badge after 5 seconds
    setTimeout(() => {
      window.updateFaviconBadge(false);
    }, 5000);
  };
  handleAllowNotification = () => {
    if (!('Notification' in window)) return;
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        this.setState({ NotificationTitle: 'Notifications Allowed' });
      }
    });
  };

  handleSwitchChange = (value) => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_AgentStatus}/${getUserID()}/agent-status`,
      data: { status: value },
    }).then(() => console.log('Status changed'));
    this.setState({ agentStatus: value });
  };

  rejectChat = (id) => {
    this.setState((prev) => ({
      chatInvitations: prev.chatInvitations.filter((inv) => inv !== id),
    }));
  };

  handleChangeProperty = (e) => {
    if (e.value === '-1') {
      this.handleChangePropertyIDAll();
    } else {
      const element = this.props.plist.find((i) => i.id === e.value);
      if (element)
        this.handleChangePropertyID(
          element.id,
          element.timeZone,
          element.currency
        );
    }
  };

  onSearchKey = (e) => {
    const text = e.target.value.toLowerCase();
    this.setState({
      propertyList: this.props.plist.filter((a) =>
        a.name.toLowerCase().includes(text)
      ),
    });
  };

  handleHelpCenter = (e) => {
    e.preventDefault();
    window.open(this.state.helpcenterUrl || 'https://help.myma.ai/en/');
  };

  getWizardSessionStatus = () => {
    AxiosAPI({
      method: 'get',
      url: `${getAPI_OnboardSetUpWizardByGroupId}/${getGroupID()}/list`,
    })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          const isAllInProgress = res.data.every(
            (item) => item.sessionStatus === 'InProgress'
          );

          this.setState({
            wizardStatus: isAllInProgress ? 'InProgress' : 'Completed',
          });
        }
      })
      .catch((err) => {
        console.error('Wizard session status error', err);
      });
  };

  getPropertyTime = (timeZone) => {
    try {
      // ❗ handle invalid values
      if (!timeZone || timeZone === 'None') {
        timeZone = 'UTC'; // fallback
      }

      return new Intl.DateTimeFormat('en-US', {
        timeZone,
        dateStyle: 'medium',
        timeStyle: 'short',
      }).format(new Date());
    } catch (err) {
      console.error('Invalid timezone:', timeZone);

      // fallback safe
      return new Intl.DateTimeFormat('en-US', {
        timeZone: 'UTC',
        dateStyle: 'medium',
        timeStyle: 'short',
      }).format(new Date());
    }
  };
  handleToggleChange = (type) => {
    if (
      type === 'browser' &&
      !this.state.notificationSettings.browser &&
      'Notification' in window
    ) {
      if (Notification.permission === 'default') {
        Notification.requestPermission().then((permission) => {
          // if (permission === "granted") {
          //   new Notification("Test", {
          //     body: "Notification enabled 🚀",
          //   });
          // }
        });
      }
    }
    this.setState(
      (prevState) => ({
        notificationSettings: {
          ...prevState.notificationSettings,
          [type]: !prevState.notificationSettings[type],
        },
      }),
      () => {
        localStorage.setItem(
          'myma_notification_settings',
          JSON.stringify(this.state.notificationSettings)
        );
      }
    );
  };
  shouldSendNotification = () => {
    const { notificationSettings } = this.state;
    return (
      notificationSettings.browser ||
      notificationSettings.mac ||
      notificationSettings.windows ||
      notificationSettings.sound
    );
  };
  render() {
    const {
      containerClassnames,
      menuClickCount,
      locale,
      user,
      usersListApp: { isSuperAdmin },
      signalRConnection,
      serviceProvider,
    } = this.props;

    // Fix: single sort using a proper string comparator — no double sort, no NaN
    const proList = this.props.plist
      ? [{ id: '-1', name: 'All' }, ...this.props.plist].sort(function (a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        })
      : [];

    const hotelName = this.state.hotelName || 'Group Info';
    const website = this.state.websiteLink || '';
    const rooms = this.state.rooms || 0;
    const groupName = this.state.groupName || '-';
    const activationDate =
      this.state.activationdate &&
      moment(this.state.activationdate).format('MMM DD, YYYY') !==
        'Jan 01, 0001'
        ? moment(this.state.activationdate).format('MMM DD, YYYY')
        : null;

    return (
      <Fragment>
        <nav className="navbar fixed-top">
          <div className="d-flex align-items-center navbar-left">
            {serviceProvider &&
            serviceProvider !== '2' &&
            serviceProvider !== '5' ? (
              <NavLink
                to="#"
                className="menu-button d-none d-md-block"
                onClick={this.menuClickButton}
              >
                <MenuIcon />
              </NavLink>
            ) : (
              <NavLink
                to="#"
                className="menu-button d-none d-md-block"
                onClick={(e) =>
                  this.menuButtonClick(e, menuClickCount, containerClassnames)
                }
              >
                <MenuIcon />
              </NavLink>
            )}
            <NavLink
              to="#"
              className="menu-button-mobile d-xs-block d-sm-block d-md-none"
              onClick={(e) =>
                this.mobileMenuButtonClick(e, containerClassnames)
              }
            >
              <MobileMenuIcon />
            </NavLink>

            <div className="d-inline-block">
              <UncontrolledDropdown className="ml-2">
                <DropdownToggle
                  caret
                  color="light"
                  size="sm"
                  className="language-button"
                >
                  <span className="name">
                    <b>
                      {this.state.hotelName === 'All'
                        ? 'Group Info'
                        : this.state.hotelName}
                    </b>
                  </span>
                </DropdownToggle>
                <DropdownMenu
                  style={{ maxHeight: '400px', overflowY: 'auto' }}
                  className="mt-3"
                  right
                >
                  <div className="search-property">
                    <input
                      type="text"
                      placeholder="Search"
                      onKeyUp={this.onSearchKey}
                    />
                  </div>
                  {this.props.plist?.length > 0 && (
                    <DropdownItem onClick={this.handleChangePropertyIDAll}>
                      Group Info
                    </DropdownItem>
                  )}
                  {this.props.plist
                    ? this.state.propertyList
                        .sort(function (a, b) {
                          if (a.name < b.name) {
                            return -1;
                          }
                          if (a.name > b.name) {
                            return 1;
                          }
                          return 0;
                        })
                        .sort((a, b) => a.name - b.name)
                        .map((element, index) => {
                          return (
                            <DropdownItem
                              onClick={() =>
                                this.handleChangePropertyID(
                                  element.id,
                                  element.timeZone,
                                  element.currency
                                )
                              }
                              key={index}
                            >
                              {element.name}
                            </DropdownItem>
                          );
                        })
                    : []}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>

            <div className="d-inline-block">
              <UncontrolledDropdown className="ml-2">
                <DropdownToggle
                  caret
                  color="light"
                  size="xs"
                  className="language-option"
                >
                  <span className="name">{locale.toUpperCase()}</span>
                </DropdownToggle>
                <DropdownMenu className="mt-3" right>
                  {localeOptions.map((elem, index) => (
                    <DropdownItem
                      key={index}
                      onClick={() =>
                        this.handleChangeLocale(elem.id, elem.direction)
                      }
                    >
                      {elem?.name}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </div>

          <a className="navbar-logo" href="/">
            {this.props.serviceProviderLogo && (
              <img
                src={this.props.serviceProviderLogo}
                width={1168 / 9}
                height={158 / 2}
                alt="logo"
              />
            )}
          </a>

          <div className="navbar-right">
            <div className="header-icons d-inline-block align-middle">
              {this.props.usersListApp?.isSuperAdmin === true &&
                [2, 5].includes(Number(this.props.serviceProvider)) &&
                this.state.isWizard && (
                  <div
                    className="setup-wizard-icon"
                    style={{ marginRight: '10px', marginTop: '6px' }}
                  >
                    {/* <a
                      onClick={this.handleSetupWizard}
                      className="header-icon d-sm-inline-block"
                      title="Setup Wizard"
                    >
                      <div className="wizard-icon-wrapper">
                        <MdOutlineAirplanemodeActive
                          size={26}
                          className="wizard-icon-inner"
                          color="var(--theme-color-1)"
                        />
                        {this.state.wizardStatus === 'InProgress' && (
                          <span className="wizard-badge">1</span>
                        )}
                      </div>
                    </a> */}
                  </div>
                )}

              {this.state.isAivaProperty === true && (
                <TopnavEasyAccess
                  handleAivaRedirect={this.handleAivaRedirect}
                />
              )}

              {!this.state.showAgentStatus && (
                <Fragment>
                  <a
                    href="#"
                    className="header-icon d-sm-inline-block"
                    title="You need agent role to take over conversations or accept Live Chat requests."
                  >
                    <img src="/assets/img/bot-off.png" width={25} height={25} />
                  </a>
                  <a
                    href="#"
                    className="header-icon d-sm-inline-block"
                    title="You need agent role to take over conversations or accept Live Chat requests."
                  >
                    <img
                      src="/assets/img/agent-off.png"
                      width={25}
                      height={25}
                    />
                  </a>
                </Fragment>
              )}

              {this.state.showAgentStatus && (
                <Fragment>
                  <a
                    onClick={this.handleLatestBotConversation}
                    className="header-icon d-sm-inline-block"
                    title="Active Conversations"
                  >
                    <img
                      src={
                        this.state.showBotConversationOn
                          ? '/assets/img/bot-on.png'
                          : '/assets/img/bot-off.png'
                      }
                      width={25}
                      height={25}
                      className={
                        this.state.showBotConversationOn ? 'blink' : ''
                      }
                    />
                  </a>
                  <a
                    onClick={this.handleAgentConversationClick}
                    className="header-icon d-sm-inline-block"
                    title="Agent Conversations"
                  >
                    <img
                      src={
                        this.state.showAgentConversation
                          ? '/assets/img/agent-on.png'
                          : '/assets/img/agent-off.png'
                      }
                      width={25}
                      height={25}
                      className={
                        this.state.showAgentConversation ? 'blink' : ''
                      }
                    />
                  </a>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-3 d-sm-inline-block"
                    checked={this.state.agentStatus}
                    onChange={(val) => this.handleSwitchChange(val)}
                  />
                  <span
                    className="ml-2 align-bottom"
                    style={{ fontSize: '0.8rem' }}
                  >
                    {this.state.agentStatus ? (
                      <IntlMessages id="dashboards.online" />
                    ) : (
                      <IntlMessages id="dashboards.offline" />
                    )}
                  </span>
                </Fragment>
              )}
            </div>

            <div className="user d-inline-block">
              <UncontrolledDropdown className="dropdown-menu-right">
                <DropdownToggle className="p-0" color="empty">
                  <span className="name mr-1">{user?.profile.name}</span>
                  <button
                    className="header-icon btn btn-empty d-none d-sm-inline-block"
                    id="fullScreenButton"
                    onClick={this.toggleFullScreen}
                  >
                    <i
                      className={`${this.state.isInFullScreen ? 'simple-icon-size-actual' : 'simple-icon-size-fullscreen'} d-block`}
                    />
                  </button>
                  <button
                    className="header-icon btn btn-empty d-none d-sm-inline-block"
                    type="button"
                  >
                    <i className="d-block simple-icon-settings" />
                  </button>

                  <button
                    className="header-icon btn btn-empty d-sm-inline-block help-icon"
                    onClick={this.handleHelpCenter}
                  >
                    ?
                  </button>
                </DropdownToggle>

                <DropdownMenu className="mt-3" right>
                  <DropdownItem>
                    <div className="user-info">
                      <div className="row">
                        <div className="col-md-2">
                          <div className="round-name">
                            <span>
                              <b>
                                {(() => {
                                  const name =
                                    user?.profile?.name?.trim() || '';
                                  if (!name) return 'NA';
                                  const parts = name.split(' ');
                                  return parts.length >= 2
                                    ? parts[0][0] + parts[1][0]
                                    : name.substring(0, 2);
                                })()}
                              </b>
                            </span>
                          </div>
                        </div>
                        <div className="col-md-9 hello-nav d-flex justify-content-between">
                          <div>
                            <p className="mb-0">
                              <IntlMessages id="dashboards.hello" />,
                            </p>
                            <h6 className="mb-0">
                              <b>{user?.profile.name}</b>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </DropdownItem>

                  <DropdownItem onClick={this.handleChangePassword}>
                    <IntlMessages id="dashboards.change-password" />
                  </DropdownItem>
                  <DropdownItem onClick={this.handleLogout}>
                    <IntlMessages id="dashboards.sign-out" />
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={this.handlePrivacy}>
                    <IntlMessages id="dashboards.privacy-policy" />
                  </DropdownItem>
                  <DropdownItem onClick={this.handleHelpCenter}>
                    <IntlMessages id="dashboards.help-center" />
                  </DropdownItem>

                  {this.state.linkedGroups.length > 1 && (
                    <Fragment>
                      <DropdownItem divider />
                      <DropdownItem onClick={this.toggleSwitchAccount}>
                        <IntlMessages id="dashboards.switch-account" />
                      </DropdownItem>
                    </Fragment>
                  )}

                  {this.props.propertyId !== '-1' &&
                    (getUserRole() === 'Admin' ||
                      getUserRole() === 'SuperAdmin') && (
                      <Fragment>
                        <DropdownItem divider />
                        <DropdownItem onClick={this.toggleBussinessPopup}>
                          <IntlMessages id="dashboards.business-settings" />
                        </DropdownItem>
                      </Fragment>
                    )}

                  {this.state.stripeCustomerId !== '' &&
                    (getUserRole() === 'Admin' ||
                      getUserRole() === 'SuperAdmin') && (
                      <Fragment>
                        <DropdownItem onClick={this.handleInvoices}>
                          <IntlMessages id="dashboards.invoice-&-payments" />
                        </DropdownItem>
                        <DropdownItem onClick={this.handleSubscription}>
                          <IntlMessages id="dashboards.upgrade-plan" />
                        </DropdownItem>
                      </Fragment>
                    )}

                  <Fragment>
                    <DropdownItem divider />
                    <DropdownItem
                      className="pb-2"
                      onClick={this.handleAllowNotification}
                    >
                      {this.state.NotificationTitle ===
                      'Notifications Allowed' ? (
                        <IntlMessages id="dashboards.notificationsAllowed" />
                      ) : (
                        <IntlMessages id="dashboards.allowNotifications" />
                      )}
                    </DropdownItem>
                    <div className="px-3 py-2">
                      {['sound', 'browser'].map((key) => (
                        <div
                          key={key}
                          className="d-flex justify-content-between mt-2"
                        >
                          <IntlMessages id={`dashboards.${key}`} />
                          <Switch
                            checked={this.state.notificationSettings[key]}
                            onChange={() => this.handleToggleChange(key)}
                          />
                        </div>
                      ))}
                      {isDarkSwitchActive && (
                        <div className="d-flex justify-content-between mt-2">
                          <IntlMessages id="dashboards.dark-theme" />
                          <TopnavDarkSwitch />
                        </div>
                      )}
                    </div>
                  </Fragment>

                  <DropdownItem divider />
                  <div className="top-item mt-2 text-muted small">
                    <b>{hotelName}</b>
                  </div>
                  <div className="top-item small">
                    {website ? (
                      <a
                        onClick={this.handleWebsiteLink}
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        className="d-flex align-items-center"
                      >
                        <i className="simple-icon-link mr-2" />
                        Go to Website
                      </a>
                    ) : (
                      'N/A'
                    )}
                  </div>
                  <div className="top-item small">
                    <div>
                      <b>Property Time</b>
                    </div>
                    <div
                      style={{
                        fontSize: '12px',
                        color: '#888',
                        marginTop: '2px',
                      }}
                    >
                      {this.state.timeZone || 'GMT'}
                    </div>
                    <div>{this.state.propertyTime || 'N/A'}</div>
                  </div>
                  {rooms > 0 && (
                    <div className="top-item small">Rooms: {rooms}</div>
                  )}
                  <div className="top-item small">
                    <b>Group: </b>
                    <p
                      style={{
                        fontSize: '12px',
                        color: '#888',
                        marginTop: '2px',
                      }}
                    >
                      {groupName || 'N/A'}
                    </p>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </div>
        </nav>

        <Modal
          isOpen={this.state.showLinkedGroups}
          keyboard={false}
          backdrop="static"
          toggle={this.toggleSwitchAccount}
        >
          <ModalHeader>Choose the Group to Switch</ModalHeader>
          <ModalBody>
            {this.state.loading ? (
              <div>
                <div className="text-center loading" />
                <p>Your request is in progress</p>
              </div>
            ) : (
              <Select
                isMulti={false}
                className="react-select"
                classNamePrefix="react-select"
                name="id"
                placeholder="Select Group or Property"
                onChange={this.handleChangeSelect}
                options={
                  this.state.linkedGroups
                    ? reactSelectProperties(
                        this.state.linkedGroups,
                        true,
                        'id',
                        'name',
                        'propertyId'
                      )
                    : []
                }
              />
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleSwitchAccount}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        {this.state.chatInvitations.length > 0 && (
          <div className="ongoing">
            <ul style={{ float: 'right' }}>
              {this.state.chatInvitations.map((person, i) => (
                <div
                  key={person}
                  className="msg_box"
                  style={{ right: `${270 * i}px` }}
                >
                  <div className="msg_head">
                    <div
                      className="chatclose"
                      onClick={() => this.rejectChat(person)}
                    >
                      x
                    </div>
                  </div>
                  <div className="msg_wrap">
                    <div className="msg_body">
                      <p>
                        User requested to chat with an agent. Open queue to view
                        and accept the chat.
                      </p>
                      <p>
                        <Button
                          color="primary"
                          outline
                          size="xs"
                          onClick={() => this.acceptChat(person)}
                          style={{ borderRadius: '6px' }}
                        >
                          Go to Queue
                        </Button>{' '}
                        <Button
                          color="secondary"
                          outline
                          size="xs"
                          onClick={() => this.rejectChat(person)}
                          style={{ borderRadius: '6px' }}
                        >
                          Cancel
                        </Button>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </ul>
          </div>
        )}

        {this.state.isShowChat === true && (
          <Intercom
            propertyName={this.state.hotelName}
            groupName={this.state.groupName}
          />
        )}

        <BusinessProfile
          visible={this.state.bussinessProfileVisible}
          toggle={() => this.setState({ bussinessProfileVisible: false })}
          propertyId={this.props.propertyId}
          groupId={getGroupID()}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  menu,
  settings,
  oidc,
  usersListApp,
  signalRConnection,
  twilioConversationsReducer,
}) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  const { locale, propertyId, serviceProviderLogo, serviceProvider } = settings;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
    locale,
    propertyId,
    user: oidc.user,
    usersListApp,
    signalRConnection,
    serviceProviderLogo,
    serviceProvider,
    twilioConversationsReducer,
  };
};

export default injectIntl(
  connect(mapStateToProps, {
    setContainerClassnames,
    clickOnMobileMenu,
    logoutUser,
    changeLocale,
    changeProperty,
    changeTimeZone,
    changeCurrency,
    changeGroupBillingCurrency,
    getPropertyList,
    ConnectUser,
    SetAgent,
    BotBlink,
    AgentBlink,
    changePropertyProvider,
    changeServiceProvider,
    changeServiceProviderLogo,
    fetchTwilioConversationsRequest,
  })(TopNav)
);
